<div>
  <ng-container *ngComponentOutlet="params.colDef.customRenderer; injector: injector;"></ng-container>
</div>